export const COUNTRIES_PHONE_PREFIX = [
  {
    name: 'Afghanistan',
    code: 'AF',
    prefixPhone: '+93',
  },
  {
    name: 'Aland Islands',
    code: 'AX',
    prefixPhone: '+358',
  },
  {
    name: 'Albania',
    code: 'AL',
    prefixPhone: '+355',
  },
  {
    name: 'Algeria',
    code: 'DZ',
    prefixPhone: '+213',
  },
  {
    name: 'American Samoa',
    code: 'AS',
    prefixPhone: '+1-684',
  },
  {
    name: 'Andorra',
    code: 'AD',
    prefixPhone: '+376',
  },
  {
    name: 'Angola',
    code: 'AO',
    prefixPhone: '+244',
  },
  {
    name: 'Anguilla',
    code: 'AI',
    prefixPhone: '+1-264',
  },
  {
    name: 'Antarctica',
    code: 'AQ',
    prefixPhone: '+672',
  },
  {
    name: 'Antigua and Barbuda',
    code: 'AG',
    prefixPhone: '+1-268',
  },
  {
    name: 'Argentina',
    code: 'AR',
    prefixPhone: '+54',
  },
  {
    name: 'Armenia',
    code: 'AM',
    prefixPhone: '+374',
  },
  {
    name: 'Aruba',
    code: 'AW',
    prefixPhone: '+297',
  },
  {
    name: 'Australia',
    code: 'AU',
    prefixPhone: '+61',
  },
  {
    name: 'Austria',
    code: 'AT',
    prefixPhone: '+43',
  },
  {
    name: 'Azerbaijan',
    code: 'AZ',
    prefixPhone: '+994',
  },
  {
    name: 'Bahamas',
    code: 'BS',
    prefixPhone: '+1-242',
  },
  {
    name: 'Bahrain',
    code: 'BH',
    prefixPhone: '+973',
  },
  {
    name: 'Bangladesh',
    code: 'BD',
    prefixPhone: '+880',
  },
  {
    name: 'Barbados',
    code: 'BB',
    prefixPhone: '+1-246',
  },
  {
    name: 'Belarus',
    code: 'BY',
    prefixPhone: '+375',
  },
  {
    name: 'Belgium',
    code: 'BE',
    prefixPhone: '+32',
  },
  {
    name: 'Belize',
    code: 'BZ',
    prefixPhone: '+501',
  },
  {
    name: 'Benin',
    code: 'BJ',
    prefixPhone: '+229',
  },
  {
    name: 'Bermuda',
    code: 'BM',
    prefixPhone: '+1-441',
  },
  {
    name: 'Bhutan',
    code: 'BT',
    prefixPhone: '+975',
  },
  {
    name: 'Bolivia',
    code: 'BO',
    prefixPhone: '+591',
  },
  {
    name: 'Bonaire  Sint Eustatius and Saba',
    code: 'BQ',
    prefixPhone: null,
  },
  {
    name: 'Bosnia and Herzegovina',
    code: 'BA',
    prefixPhone: '+387',
  },
  {
    name: 'Botswana',
    code: 'BW',
    prefixPhone: '+267',
  },
  {
    name: 'Bouvet Island',
    code: 'BV',
    prefixPhone: '+55',
  },
  {
    name: 'Brazil',
    code: 'BR',
    prefixPhone: '+55',
  },
  {
    name: 'British Indian Ocean Territory',
    code: 'IO',
    prefixPhone: '0',
  },
  {
    name: 'Brunei',
    code: 'BN',
    prefixPhone: '+673',
  },
  {
    name: 'Bulgaria',
    code: 'BG',
    prefixPhone: '+359',
  },
  {
    name: 'Burkina Faso',
    code: 'BF',
    prefixPhone: '+226',
  },
  {
    name: 'Burundi',
    code: 'BI',
    prefixPhone: '+257',
  },
  {
    name: 'Cambodia',
    code: 'KH',
    prefixPhone: '+855',
  },
  {
    name: 'Cameroon',
    code: 'CM',
    prefixPhone: '+237',
  },
  {
    name: 'Canada',
    code: 'CA',
    prefixPhone: '+1',
  },
  {
    name: 'Cape Verde',
    code: 'CV',
    prefixPhone: '+238',
  },
  {
    name: 'Cayman Islands',
    code: 'KY',
    prefixPhone: '+1-345',
  },
  {
    name: 'Central African Republic',
    code: 'CF',
    prefixPhone: '+236',
  },
  {
    name: 'Chad',
    code: 'TD',
    prefixPhone: '+235',
  },
  {
    name: 'Chile',
    code: 'CL',
    prefixPhone: '+56',
  },
  {
    name: 'China',
    code: 'CN',
    prefixPhone: '+86',
  },
  {
    name: 'Christmas Island',
    code: 'CX',
    prefixPhone: '+53',
  },
  {
    name: 'Cocos (Keeling) Islands',
    code: 'CC',
    prefixPhone: '+61',
  },
  {
    name: 'Colombia',
    code: 'CO',
    prefixPhone: '+57',
  },
  {
    name: 'Comoros',
    code: 'KM',
    prefixPhone: '+269',
  },
  {
    name: 'Congo',
    code: 'CG',
    prefixPhone: '+242',
  },
  {
    name: 'Cook Islands',
    code: 'CK',
    prefixPhone: '+682',
  },
  {
    name: 'Costa Rica',
    code: 'CR',
    prefixPhone: '+506',
  },
  {
    name: 'Ivory Coast',
    code: 'CI',
    prefixPhone: '+225',
  },
  {
    name: 'Croatia',
    code: 'HR',
    prefixPhone: '+385',
  },
  {
    name: 'Cuba',
    code: 'CU',
    prefixPhone: '+53',
  },
  {
    name: 'Curacao',
    code: 'CW',
    prefixPhone: '+599',
  },
  {
    name: 'Cyprus',
    code: 'CY',
    prefixPhone: '+357',
  },
  {
    name: 'Czech Republic',
    code: 'CZ',
    prefixPhone: '+420',
  },
  {
    name: 'Democratic Republic of the Congo',
    code: 'CD',
    prefixPhone: '+243',
  },
  {
    name: 'Denmark',
    code: 'DK',
    prefixPhone: '+45',
  },
  {
    name: 'Djibouti',
    code: 'DJ',
    prefixPhone: '+253',
  },
  {
    name: 'Dominica',
    code: 'DM',
    prefixPhone: '+1-767',
  },
  {
    name: 'Dominican Republic',
    code: 'DO',
    prefixPhone: '+1-809',
  },
  {
    name: 'Ecuador',
    code: 'EC',
    prefixPhone: '+593 ',
  },
  {
    name: 'Egypt',
    code: 'EG',
    prefixPhone: '+20',
  },
  {
    name: 'El Salvador',
    code: 'SV',
    prefixPhone: '+503',
  },
  {
    name: 'Equatorial Guinea',
    code: 'GQ',
    prefixPhone: '+240',
  },
  {
    name: 'Eritrea',
    code: 'ER',
    prefixPhone: '+291',
  },
  {
    name: 'Estonia',
    code: 'EE',
    prefixPhone: '+372',
  },
  {
    name: 'Ethiopia',
    code: 'ET',
    prefixPhone: '+251',
  },
  {
    name: 'Falkland Islands (Malvinas)',
    code: 'FK',
    prefixPhone: '+500',
  },
  {
    name: 'Faroe Islands',
    code: 'FO',
    prefixPhone: '+298',
  },
  {
    name: 'Fiji',
    code: 'FJ',
    prefixPhone: '+679',
  },
  {
    name: 'Finland',
    code: 'FI',
    prefixPhone: '+358',
  },
  {
    name: 'France',
    code: 'FR',
    prefixPhone: '+33',
  },
  {
    name: 'French Guiana',
    code: 'GF',
    prefixPhone: '+594',
  },
  {
    name: 'French Polynesia',
    code: 'PF',
    prefixPhone: '+689',
  },
  {
    name: 'French Southern Territories',
    code: 'TF',
    prefixPhone: '0',
  },
  {
    name: 'Gabon',
    code: 'GA',
    prefixPhone: '+241',
  },
  {
    name: 'Gambia',
    code: 'GM',
    prefixPhone: '+220',
  },
  {
    name: 'Georgia',
    code: 'GE',
    prefixPhone: '+995',
  },
  {
    name: 'Germany',
    code: 'DE',
    prefixPhone: '+49',
  },
  {
    name: 'Ghana',
    code: 'GH',
    prefixPhone: '+233',
  },
  {
    name: 'Gibraltar',
    code: 'GI',
    prefixPhone: '+350',
  },
  {
    name: 'Greece',
    code: 'GR',
    prefixPhone: '+30',
  },
  {
    name: 'Greenland',
    code: 'GL',
    prefixPhone: '+299',
  },
  {
    name: 'Grenada',
    code: 'GD',
    prefixPhone: '+1-473',
  },
  {
    name: 'Guadaloupe',
    code: 'GP',
    prefixPhone: '+590',
  },
  {
    name: 'Guam',
    code: 'GU',
    prefixPhone: '+1-671',
  },
  {
    name: 'Guatemala',
    code: 'GT',
    prefixPhone: '+502',
  },
  {
    name: 'Guernsey',
    code: 'GG',
    prefixPhone: '+44',
  },
  {
    name: 'Guinea',
    code: 'GN',
    prefixPhone: '+224',
  },
  {
    name: 'Guinea-Bissau',
    code: 'GW',
    prefixPhone: '+245',
  },
  {
    name: 'Guyana',
    code: 'GY',
    prefixPhone: '+592',
  },
  {
    name: 'Haiti',
    code: 'HT',
    prefixPhone: '+509',
  },
  {
    name: 'Heard Island and McDonald Islands',
    code: 'HM',
    prefixPhone: '0',
  },
  {
    name: 'Honduras',
    code: 'HN',
    prefixPhone: '+504',
  },
  {
    name: 'Hong Kong',
    code: 'HK',
    prefixPhone: '+852',
  },
  {
    name: 'Hungary',
    code: 'HU',
    prefixPhone: '+36',
  },
  {
    name: 'Iceland',
    code: 'IS',
    prefixPhone: '+354',
  },
  {
    name: 'India',
    code: 'IN',
    prefixPhone: '+91',
  },
  {
    name: 'Indonesia',
    code: 'ID',
    prefixPhone: '+62',
  },
  {
    name: 'Iran',
    code: 'IR',
    prefixPhone: '+98',
  },
  {
    name: 'Iraq',
    code: 'IQ',
    prefixPhone: '+964',
  },
  {
    name: 'Ireland',
    code: 'IE',
    prefixPhone: '+353',
  },
  {
    name: 'Isle of Man',
    code: 'IM',
    prefixPhone: '+44',
  },
  {
    name: 'Israel',
    code: 'IL',
    prefixPhone: '+972',
  },
  {
    name: 'Italy',
    code: 'IT',
    prefixPhone: '+39',
  },
  {
    name: 'Jamaica',
    code: 'JM',
    prefixPhone: '+1-876',
  },
  {
    name: 'Japan',
    code: 'JP',
    prefixPhone: '+81',
  },
  {
    name: 'Jersey',
    code: 'JE',
    prefixPhone: '+44',
  },
  {
    name: 'Jordan',
    code: 'JO',
    prefixPhone: '+962',
  },
  {
    name: 'Kazakhstan',
    code: 'KZ',
    prefixPhone: '+7',
  },
  {
    name: 'Kenya',
    code: 'KE',
    prefixPhone: '+254',
  },
  {
    name: 'Kiribati',
    code: 'KI',
    prefixPhone: '+686',
  },
  {
    name: 'Kosovo',
    code: 'XK',
    prefixPhone: '+383',
  },
  {
    name: 'Kuwait',
    code: 'KW',
    prefixPhone: '+965',
  },
  {
    name: 'Kyrgyzstan',
    code: 'KG',
    prefixPhone: '+996',
  },
  {
    name: 'Laos',
    code: 'LA',
    prefixPhone: '+856',
  },
  {
    name: 'Latvia',
    code: 'LV',
    prefixPhone: '+371',
  },
  {
    name: 'Lebanon',
    code: 'LB',
    prefixPhone: '+961',
  },
  {
    name: 'Lesotho',
    code: 'LS',
    prefixPhone: '+266',
  },
  {
    name: 'Liberia',
    code: 'LR',
    prefixPhone: '+231',
  },
  {
    name: 'Libya',
    code: 'LY',
    prefixPhone: '+218',
  },
  {
    name: 'Liechtenstein',
    code: 'LI',
    prefixPhone: '+423',
  },
  {
    name: 'Lithuania',
    code: 'LT',
    prefixPhone: '+370',
  },
  {
    name: 'Luxembourg',
    code: 'LU',
    prefixPhone: '+352',
  },
  {
    name: 'Macao',
    code: 'MO',
    prefixPhone: '+853',
  },
  {
    name: 'Macedonia',
    code: 'MK',
    prefixPhone: '+389',
  },
  {
    name: 'Madagascar',
    code: 'MG',
    prefixPhone: '+261',
  },
  {
    name: 'Malawi',
    code: 'MW',
    prefixPhone: '+265',
  },
  {
    name: 'Malaysia',
    code: 'MY',
    prefixPhone: '+60',
  },
  {
    name: 'Maldives',
    code: 'MV',
    prefixPhone: '+960',
  },
  {
    name: 'Mali',
    code: 'ML',
    prefixPhone: '+223',
  },
  {
    name: 'Malta',
    code: 'MT',
    prefixPhone: '+356',
  },
  {
    name: 'Marshall Islands',
    code: 'MH',
    prefixPhone: '+692',
  },
  {
    name: 'Martinique',
    code: 'MQ',
    prefixPhone: '+596',
  },
  {
    name: 'Mauritania',
    code: 'MR',
    prefixPhone: '+222',
  },
  {
    name: 'Mauritius',
    code: 'MU',
    prefixPhone: '+230',
  },
  {
    name: 'Mayotte',
    code: 'YT',
    prefixPhone: '+269',
  },
  {
    name: 'Mexico',
    code: 'MX',
    prefixPhone: '+52',
  },
  {
    name: 'Micronesia',
    code: 'FM',
    prefixPhone: '+691',
  },
  {
    name: 'Moldava',
    code: 'MD',
    prefixPhone: '+373',
  },
  {
    name: 'Monaco',
    code: 'MC',
    prefixPhone: '+377',
  },
  {
    name: 'Mongolia',
    code: 'MN',
    prefixPhone: '+976',
  },
  {
    name: 'Montenegro',
    code: 'ME',
    prefixPhone: '+382',
  },
  {
    name: 'Montserrat',
    code: 'MS',
    prefixPhone: '+1-664',
  },
  {
    name: 'Morocco',
    code: 'MA',
    prefixPhone: '+212',
  },
  {
    name: 'Mozambique',
    code: 'MZ',
    prefixPhone: '+258',
  },
  {
    name: 'Myanmar (Burma)',
    code: 'MM',
    prefixPhone: '+95',
  },
  {
    name: 'Namibia',
    code: 'NA',
    prefixPhone: '+264',
  },
  {
    name: 'Nauru',
    code: 'NR',
    prefixPhone: '+674',
  },
  {
    name: 'Nepal',
    code: 'NP',
    prefixPhone: '+977',
  },
  {
    name: 'Netherlands',
    code: 'NL',
    prefixPhone: '+31',
  },
  {
    name: 'New Caledonia',
    code: 'NC',
    prefixPhone: '+687',
  },
  {
    name: 'New Zealand',
    code: 'NZ',
    prefixPhone: '+64',
  },
  {
    name: 'Nicaragua',
    code: 'NI',
    prefixPhone: '+505',
  },
  {
    name: 'Niger',
    code: 'NE',
    prefixPhone: '+227',
  },
  {
    name: 'Nigeria',
    code: 'NG',
    prefixPhone: '+234',
  },
  {
    name: 'Niue',
    code: 'NU',
    prefixPhone: '+683',
  },
  {
    name: 'Norfolk Island',
    code: 'NF',
    prefixPhone: '+672',
  },
  {
    name: 'North Korea',
    code: 'KP',
    prefixPhone: '+850',
  },
  {
    name: 'Northern Mariana Islands',
    code: 'MP',
    prefixPhone: '+1-670',
  },
  {
    name: 'Norway',
    code: 'NO',
    prefixPhone: '+47',
  },
  {
    name: 'Oman',
    code: 'OM',
    prefixPhone: '+968',
  },
  {
    name: 'Pakistan',
    code: 'PK',
    prefixPhone: '+92',
  },
  {
    name: 'Palau',
    code: 'PW',
    prefixPhone: '+680',
  },
  {
    name: 'Palestine',
    code: 'PS',
    prefixPhone: '+970',
  },
  {
    name: 'Panama',
    code: 'PA',
    prefixPhone: '+507',
  },
  {
    name: 'Papua New Guinea',
    code: 'PG',
    prefixPhone: '+675',
  },
  {
    name: 'Paraguay',
    code: 'PY',
    prefixPhone: '+595',
  },
  {
    name: 'Peru',
    code: 'PE',
    prefixPhone: '+51',
  },
  {
    name: 'Phillipines',
    code: 'PH',
    prefixPhone: '+63',
  },
  {
    name: 'Pitcairn',
    code: 'PN',
    prefixPhone: '0',
  },
  {
    name: 'Poland',
    code: 'PL',
    prefixPhone: '+48',
  },
  {
    name: 'Portugal',
    code: 'PT',
    prefixPhone: '+351',
  },
  {
    name: 'Puerto Rico',
    code: 'PR',
    prefixPhone: '+1-787',
  },
  {
    name: 'Qatar',
    code: 'QA',
    prefixPhone: '+974 ',
  },
  {
    name: 'Reunion',
    code: 'RE',
    prefixPhone: '+262',
  },
  {
    name: 'Romania',
    code: 'RO',
    prefixPhone: '+40',
  },
  {
    name: 'Russia',
    code: 'RU',
    prefixPhone: '+7',
  },
  {
    name: 'Rwanda',
    code: 'RW',
    prefixPhone: '+250',
  },
  {
    name: 'Saint Barthelemy',
    code: 'BL',
    prefixPhone: '+590',
  },
  {
    name: 'Saint Helena',
    code: 'SH',
    prefixPhone: '+290',
  },
  {
    name: 'Saint Kitts and Nevis',
    code: 'KN',
    prefixPhone: '+1-869',
  },
  {
    name: 'Saint Lucia',
    code: 'LC',
    prefixPhone: '+1-758',
  },
  {
    name: 'Saint Martin',
    code: 'MF',
    prefixPhone: '+590',
  },
  {
    name: 'Saint Pierre and Miquelon',
    code: 'PM',
    prefixPhone: '+508',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    code: 'VC',
    prefixPhone: '+1-784',
  },
  {
    name: 'Samoa',
    code: 'WS',
    prefixPhone: '+685',
  },
  {
    name: 'San Marino',
    code: 'SM',
    prefixPhone: '+378',
  },
  {
    name: 'Sao Tome and Principe',
    code: 'ST',
    prefixPhone: '+239',
  },
  {
    name: 'Saudi Arabia',
    code: 'SA',
    prefixPhone: '+966',
  },
  {
    name: 'Senegal',
    code: 'SN',
    prefixPhone: '+221',
  },
  {
    name: 'Serbia',
    code: 'RS',
    prefixPhone: '0',
  },
  {
    name: 'Seychelles',
    code: 'SC',
    prefixPhone: '+248',
  },
  {
    name: 'Sierra Leone',
    code: 'SL',
    prefixPhone: '+232',
  },
  {
    name: 'Singapore',
    code: 'SG',
    prefixPhone: '+65',
  },
  {
    name: 'Sint Maarten',
    code: 'SX',
    prefixPhone: '+1721',
  },
  {
    name: 'Slovakia',
    code: 'SK',
    prefixPhone: '+421',
  },
  {
    name: 'Slovenia',
    code: 'SI',
    prefixPhone: '+386',
  },
  {
    name: 'Solomon Islands',
    code: 'SB',
    prefixPhone: '+677',
  },
  {
    name: 'Somalia',
    code: 'SO',
    prefixPhone: '+252',
  },
  {
    name: 'South Africa',
    code: 'ZA',
    prefixPhone: '+27',
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    code: 'GS',
    prefixPhone: '0',
  },
  {
    name: 'South Korea',
    code: 'KR',
    prefixPhone: '+82',
  },
  {
    name: 'South Sudan',
    code: 'SS',
    prefixPhone: '+211',
  },
  {
    name: 'Sri Lanka',
    code: 'LK',
    prefixPhone: '+94',
  },
  {
    name: 'Sudan',
    code: 'SD',
    prefixPhone: '+249',
  },
  {
    name: 'Suriname',
    code: 'SR',
    prefixPhone: '+597',
  },
  {
    name: 'Svalbard and Jan Mayen',
    code: 'SJ',
    prefixPhone: '0',
  },
  {
    name: 'Swaziland',
    code: 'SZ',
    prefixPhone: '+268',
  },
  {
    name: 'Sweden',
    code: 'SE',
    prefixPhone: '+46',
  },
  {
    name: 'Switzerland',
    code: 'CH',
    prefixPhone: '+41',
  },
  {
    name: 'Syria',
    code: 'SY',
    prefixPhone: '+963',
  },
  {
    name: 'Taiwan',
    code: 'TW',
    prefixPhone: '+886',
  },
  {
    name: 'Tajikistan',
    code: 'TJ',
    prefixPhone: '+992',
  },
  {
    name: 'Tanzania',
    code: 'TZ',
    prefixPhone: '+255',
  },
  {
    name: 'Thailand',
    code: 'TH',
    prefixPhone: '+66',
  },
  {
    name: 'Timor-Leste (East Timor)',
    code: 'TL',
    prefixPhone: '+670',
  },
  {
    name: 'Togo',
    code: 'TG',
    prefixPhone: '0',
  },
  {
    name: 'Tokelau',
    code: 'TK',
    prefixPhone: '+690',
  },
  {
    name: 'Tonga',
    code: 'TO',
    prefixPhone: '+676',
  },
  {
    name: 'Trinidad and Tobago',
    code: 'TT',
    prefixPhone: '+1-868',
  },
  {
    name: 'Tunisia',
    code: 'TN',
    prefixPhone: '+216',
  },
  {
    name: 'Turkey',
    code: 'TR',
    prefixPhone: '+90',
  },
  {
    name: 'Turkmenistan',
    code: 'TM',
    prefixPhone: '+993',
  },
  {
    name: 'Turks and Caicos Islands',
    code: 'TC',
    prefixPhone: '+1-649',
  },
  {
    name: 'Tuvalu',
    code: 'TV',
    prefixPhone: '+688',
  },
  {
    name: 'Uganda',
    code: 'UG',
    prefixPhone: '+256',
  },
  {
    name: 'Ukraine',
    code: 'UA',
    prefixPhone: '+380',
  },
  {
    name: 'United Arab Emirates',
    code: 'AE',
    prefixPhone: '+971',
  },
  {
    name: 'United Kingdom',
    code: 'GB',
    prefixPhone: '0',
  },
  {
    name: 'United States',
    code: 'US',
    prefixPhone: '+1',
  },
  {
    name: 'United States Minor Outlying Islands',
    code: 'UM',
    prefixPhone: '0',
  },
  {
    name: 'Uruguay',
    code: 'UY',
    prefixPhone: '+598',
  },
  {
    name: 'Uzbekistan',
    code: 'UZ',
    prefixPhone: '+998',
  },
  {
    name: 'Vanuatu',
    code: 'VU',
    prefixPhone: '+678',
  },
  {
    name: 'Vatican City',
    code: 'VA',
    prefixPhone: '0',
  },
  {
    name: 'Venezuela',
    code: 'VE',
    prefixPhone: '+58',
  },
  {
    name: 'Vietnam',
    code: 'VN',
    prefixPhone: '+84',
  },
  {
    name: 'Virgin Islands  British',
    code: 'VG',
    prefixPhone: '+1-284',
  },
  {
    name: 'Virgin Islands',
    code: 'VI',
    prefixPhone: '+1-284',
  },
  {
    name: 'Wallis and Futuna',
    code: 'WF',
    prefixPhone: '+681',
  },
  {
    name: 'Western Sahara',
    code: 'EH',
    prefixPhone: '0',
  },
  {
    name: 'Yemen',
    code: 'YE',
    prefixPhone: '+967',
  },
  {
    name: 'Zambia',
    code: 'ZM',
    prefixPhone: '+260',
  },
  {
    name: 'Zimbabwe',
    code: 'ZW',
    prefixPhone: '+263',
  },
  {
    name: 'Spain',
    code: 'ES',
    prefixPhone: '+34',
  },
] as const;

export const DEFAULT_USA_PHONE_PREFIX = 'US' as const;
